import { error } from "console";
import { loginRequestAAD, graphConfig } from "../authConfig";
import { msalInstance } from "../index";

export async function callMsGraph() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequestAAD,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => {
            if (response.ok == false) { 
                if (response.status == 401) {
                    throw new Error('Unauthorized ') 
                }
                else
                {
                    throw new Error(response.status + ' ' + response.statusText) ;
                }
            }
            else
            {
                return response.json();
            }

        })
    //.catch(error => console.log(error));
}